'use client';

import _slicedToArray from "/codebuild/output/src1286/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from 'react';
import { useId, useWindowEvent, useFocusReturn } from '@mantine/hooks';
import { useLockScroll } from './use-lock-scroll.mjs';
function useModal(_ref) {
  var id = _ref.id,
    transitionProps = _ref.transitionProps,
    opened = _ref.opened,
    trapFocus = _ref.trapFocus,
    closeOnEscape = _ref.closeOnEscape,
    onClose = _ref.onClose,
    returnFocus = _ref.returnFocus;
  var _id = useId(id);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    titleMounted = _useState2[0],
    setTitleMounted = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    bodyMounted = _useState4[0],
    setBodyMounted = _useState4[1];
  var transitionDuration = typeof (transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.duration) === "number" ? transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.duration : 200;
  var shouldLockScroll = useLockScroll({
    opened: opened,
    transitionDuration: transitionDuration
  });
  useWindowEvent("keydown", function (event) {
    if (event.key === "Escape" && closeOnEscape && opened) {
      var _event$target;
      var shouldTrigger = ((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.getAttribute("data-mantine-stop-propagation")) !== "true";
      shouldTrigger && onClose();
    }
  }, {
    capture: true
  });
  useFocusReturn({
    opened: opened,
    shouldReturnFocus: trapFocus && returnFocus
  });
  return {
    _id: _id,
    titleMounted: titleMounted,
    bodyMounted: bodyMounted,
    shouldLockScroll: shouldLockScroll,
    setTitleMounted: setTitleMounted,
    setBodyMounted: setBodyMounted
  };
}
export { useModal };